import { render } from "./emoji-select.vue?vue&type=template&id=3a9676d6"
import script from "./emoji-select.vue?vue&type=script&lang=js"
export * from "./emoji-select.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__